import React, { Component } from 'react';
import {Layout,Menu, message} from 'antd';
import {withRouter} from 'react-router-dom';
import { UserOutlined, ReloadOutlined, LogoutOutlined } from '@ant-design/icons';
import storage from '../utils/storage';
import { configs } from '../config/config';
import { route } from '../routes/routes';

const {Header} = Layout;



class HeadCustomer extends Component {
    constructor(props) {
        super(props);
        if(!storage.check(configs.cache.tokenKey)){
            this.props.history.push(route.default.login)
         }
        let userInfo = storage.get(configs.cache.tokenKey)
        let email = userInfo.email
        let name = email.substring(0,email.indexOf('@'))
  
        this.state = {
            user:false,
            items: [
                {
                  label: name,
                  key: 'user',
                  icon: <UserOutlined />,
                  children:[
                      {
                        label: 'Logout',
                        icon:<LogoutOutlined />,
                      }
                  ]
                }
            ]
        } 
    }


    logout = () => { 
        storage.clear()
        this.props.history.push(configs.default.route)
    }

    handlerRefresh = () => {
        // remove the cache data without the token

        message.success('Data has reloaded !');
    }

    render(){
        const {items} = this.state;
        return (
            <>
                <Header style={{ background: "#851dd6" }}>
                    <Menu 
                        mode="horizontal"
                        style={{ float: 'right',background:"#851dd6",width:"180px"}}
                        theme='light'
                        items={items}
                        onClick = {this.logout}
                    >
        
                        {/* <MenuItemGroup>
                                <Menu.Item key="Refresh"  >
                                    <ReloadOutlined />
                                    <span onClick = {this.handlerRefresh}>Refresh</span>
                                </Menu.Item>
                                
                                <Menu.Item key="Logout">
                                    <LogoutOutlined />
                                    <span onClick={this.logout}>Logout</span>
                                </Menu.Item>
                            </MenuItemGroup>         */}
                        {/* </SubMenu>  */}
                    </Menu>
                </Header>
            </>
        )
    }
}
export default withRouter(HeadCustomer);

